import { generatePath, matchPath } from "react-router";

/**
 * Create a object able to generate or match a route path.
 * When you match, you receive the params of the route of type T.
 * When you generate, you must provide the params of type T.
 * @param originalPath - a react-router route path - like /my-path/:someId/:someOtherId
 */
export const generateRoute = <T extends Record<string, string | number> = {}>(
  originalPath: string
) => {
  return {
    originalPath,
    generate: (routeParams: T) =>
      generatePath(
        originalPath,
        routeParams as Record<string, string | number>
      ),
    match: (pathname: string) =>
      matchPath(
        {
          path: originalPath,
          caseSensitive: true,
        },
        pathname
      ),
  };
};
